import getFeatureFlags, { defaultFeatureFlags } from './get-feature-flags';
import { getABTest, isInABTest } from './get-AB-test';
import { CULTURE_CODE } from './culture-code';
import { PLATFORM_ID } from './platform-id';
import { SITECODE } from './sitecode';
import { URL_CODE } from './url-code';
import * as FeatureFlagsImports from './feature-flags';
export var FEATURE_FLAGS = FeatureFlagsImports.FEATURE_FLAGS;
export { CULTURE_CODE, defaultFeatureFlags, getABTest, isInABTest, getFeatureFlags, PLATFORM_ID, SITECODE, URL_CODE };
